import { log } from '@domgen/shared/utils/log';
import { STORAGE_KEY } from '../../const/app';
import { PersistedState } from '../../models/store/persistedState';

/**
 * Loads persisted session state from sessionStorage, if available and valid.
 * Returns the parsed session state or undefined if not found or on error.
 * Errors during loading/parsing are caught and logged, with undefined returned.
 */
export const loadSession = (): PersistedState | undefined => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return undefined;
    return JSON.parse(raw);
  } catch (error) {
    log.error({ message: 'Failed to load session', data: error });
    return undefined;
  }
};
